import { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import Loader from '../Loader/Loader';

import AdditionalInfo from '../CommercialDeposit/AdditionalInfo';

import LoginAddress from '../OtpLogin/LoginAddress';
import PersonalInformation from '../LeadGeneration/StepOne/PersonalInformation';
import AddressInformation from '../LeadGeneration/StepOne/AddressInformation';
import CompliancePage from '../LeadGeneration/StepTwo/CompliancePage';
import FeatureScreen from '../LeadGeneration/StepTwo/FeatureScreen';
import ContactInformation from '../LeadGeneration/StepOne/ContactInformation';
import FundingScreen from '../LeadGeneration/StepTwo/FundingScreen';
import ThankyouBundle from '../Bundle/ThankyouBundle';
import BundleContact from '../Bundle/BundleContact';
import EducativeCarousel from '../Bundle/EducativeCarousel';
import ThankyouAutomatedBundle from '../Bundle/ThankyouAutomatedBundle';
import VouchedSuccess from '../Bundle/VouchedSuccess';
import VouchedFailed from '../Bundle/VouchedFailed';

const Overlay = lazy(() => import('../Overlay/Overlay'));
const FormHandler = lazy(() => import('../LeadGeneration/FormHandler'));
function Routing() {
  return (
    <div style={{ height: '100%' }}>
      <Suspense
        fallback={
          <div className="loader-style">
            <Loader />{' '}
          </div>
        }
      >
        <Switch>
          <Route exact path="/:region/:lang/:journeyType/:product/:page/" component={FormHandler} />
          <Route
            exact
            path="/:region/:lang/express/:journeyType/:product/:page/"
            component={FormHandler}
          />
          <Route exact path="/:region/:lang/:journeyType/:page/" component={FormHandler} />
          <Route exact path="/:region/:lang/:product/:page/" component={FormHandler} />
          <Route exact path="/:lang/:journeyType/:page/" component={FormHandler} />
          <Route exact path="/:lang/:page/" component={FormHandler} />
          <Route exact path="/" component={Overlay} />
          <Route exact path="/bundle" component={ThankyouAutomatedBundle} />
          {/* <Route exact path="/loader" component={LoaderCarousel} /> */}
          <Route exact path="/cd-success" component={ContactInformation} />
        </Switch>
      </Suspense>
    </div>
  );
}

export default Routing;
